import { Injectable } from '@angular/core';
import { ModalController, Platform } from '@ionic/angular';
import {
  AbsenceDetailComponent,
  AbsenceFormComponent,
  HoursDetailComponent,
  HoursFormComponent,
} from '../public-api';
import { WorkListEntry } from '../lib/models/work-list-entry';
import { ExportPopupComponent } from '../lib/export-popup/export-popup.component';

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(
    private modalController: ModalController,
    public platform: Platform
  ) {}

  public async openHoursDetailModal(
    workListEntry: WorkListEntry,
    isBigScreen: boolean
  ) {
    if (workListEntry.isAbsence) {
      await this.openAbsenceDetailModal(workListEntry.id);
      return;
    }

    const modal = await this.modalController.create({
      component: HoursDetailComponent,
      componentProps: {
        id: workListEntry.id,
      },
      //cssClass:
      //  this.platform.is('desktop') || this.platform.is('tablet')
      //   ? 'custom-desktop-modal'
      //  : '',
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      if (data == 'edit') {
        this.openHoursFormModal(workListEntry.id, isBigScreen);
      }
    }
  }

  public async openHoursFormModal(id: string, isBigScreen: boolean) {
    const modal = await this.modalController.create({
      component: HoursFormComponent,
      componentProps: {
        workDayId: id,
      },
      cssClass: isBigScreen ? 'custom-desktop-modal' : '',
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }

  public async createExportModal(
    monthYearLabel: string,
    month: number,
    year: number
  ) {
    const modal = await this.modalController.create({
      component: ExportPopupComponent,
      componentProps: {
        monthYearLabel: monthYearLabel,
        month: month,
        year: year,
      },
    });

    modal.present();
    return await modal.onWillDismiss();
  }

  public async openAbsenceDetailModal(id: string) {
    const modal = await this.modalController.create({
      component: AbsenceDetailComponent,
      componentProps: {
        paramId: id,
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      if (data == 'edit') {
        this.openAbsenceFormModal(id);
      }
    }
  }

  public async openAbsenceFormModal(
    id: string,
    preselectedUser: string = null
  ) {
    const modal = await this.modalController.create({
      component: AbsenceFormComponent,
      componentProps: {
        absenceEntryId: id,
        selectedUsers: preselectedUser ? [preselectedUser] : [],
      },
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();
  }
}
